/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable import/prefer-default-export */
import api from '@utils/axios';
import { buildingBuildingNotePath, buildingBuildingNotesPath } from '../../../routes';
export const updateNote = ({ id, buildingId, note }) => {
    const body = new FormData();
    body.append('building_note[notes]', note.notes);
    body.append('building_note[visibility]', note.visibility);
    return api.put(buildingBuildingNotePath('', buildingId, { id, format: 'json', _options: true }), body);
};
export const deleteNote = ({ id, buildingId }) => api.delete(buildingBuildingNotePath('', buildingId, { id, format: 'json', _options: true }));
export const createNote = ({ buildingId, inspectionId, workOrderId, deficiencyId, notes, visibility }) => {
    const body = new FormData();
    body.append('building_note[notes]', notes);
    body.append('building_note[visibility]', visibility);
    return api.post(buildingBuildingNotesPath('', {
        building_id: buildingId,
        inspection_id: inspectionId,
        work_order_id: workOrderId,
        deficiency_id: deficiencyId,
        format: 'json'
    }), body);
};
